import { render, staticRenderFns } from "./FeaturedModal.vue?vue&type=template&id=5aa55262"
import script from "./FeaturedModal.vue?vue&type=script&lang=js"
export * from "./FeaturedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports